<template>
  <div>
    <v-card class="mb-12" color="lighten-1">
      <v-data-table
         :headers="$t('app.taxes_headers')"
        :items="invoice.taxes"
        :items-per-page="20"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('app.new_tax')}}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{$t('app.new')}}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="newTaxItem.fname" :label="$t('app.name')"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select v-model="newTaxItem.ftype" :items="$t('app.taxTypes')" item-value="key" item-text="name" label="Type"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="newTaxItem.famount" type="number" :label="$t('app.amount_label')"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="addTax(newTaxItem),dialog = false">{{$t('app.save')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              <v-btn fab dark small color="red" @click="deleteTax(index)">
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </td>
            <td>{{item.name}}</td>
            <td>{{ $t('app.'+item.type) }}</td>
            <td>{{item.amount}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
     <v-btn color="primary" @click="nextStep">{{$t('app.continue')}}</v-btn>

    <v-btn @click="prevStep" text>{{$t('app.back')}}</v-btn>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "StepFour",
  computed: {
    ...mapState(["invoice", "e1"])
  },
  components: {},
  data() {
    return {
      dialog: false,
      taxTypes: ["rate", "amount"],
      newTaxItem: {
        fname: "",
        ftype: "",
        famount: 0
      }
    };
  },
  methods: {
    ...mapActions(["nextStep", "prevStep", "deleteTax", "addTax"])
  }
};
</script>

<style scoped>
</style>